import React, { Component, Fragment } from 'react';

function getChildWithClass(parent, classSearch) {
  for (let i = 0, max = parent.childNodes.length; i < max; i++) {
    if (parent.childNodes[i].className == classSearch) {
      return parent.childNodes[i];
    }
  }
  return false;
}

class List extends Component {
  render() {
    return <div>{this.props.name}</div>;
  }
}

class Filter extends Component {
  render() {
    return (
      <form>
        <input type="text" name="filter" />
      </form>
    );
  }
}

export default class FilterList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: '',
      files: []
    };
  }

  componentDidMount() {
    const files = [];
    const list = [...document.querySelectorAll('.file')];
    console.log(list);
    list.map(file => {
      files.push({
        name: getChildWithClass(file, 'filetitle').textContent,
        link: getChildWithClass(file, 'filetitle').href,
        size: getChildWithClass(file, 'info')
      });
    });
    console.log(files);
    // .map(file => {
    //   _files.push(file);
    // });
    // this.setState({ files: _files });
  }

  render() {
    // const files = this.state.files.map(file => {
    //   return <List ref={file} name={file} />;
    // });
    return (
      <Fragment>
        <Filter />
        <ul>
          <li>Test</li>
        </ul>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./js/Filter.js